import { LinkButton } from 'components/LinkButton';
import React, { FC, ReactNode } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Box, xcss } from '@atlaskit/primitives';

const infoViewWrapperStyle = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: token('space.200'),
});

const infoViewTitleWrapperStyle = xcss({
  textAlign: 'center',
  marginTop: 'space.300',
  marginBottom: 'space.300',
  marginLeft: '0',
  marginRight: '0',
});

interface OwnProps {
  title: string;
  hero?: ReactNode;
}

const InfoView: FC<OwnProps> = ({ title, hero }) => {
  const { translate } = useTranslation();
  return (
    <div css={infoViewWrapperStyle}>
      {hero}
      <Box as='h3' xcss={infoViewTitleWrapperStyle}>
        {title}
      </Box>
      <LinkButton appearance={'primary'} href={'https://www.atlassian.com'}>
        {translate(translationKeys.GOTO_ATLASSIAN_BUTTON_LABEL)}
      </LinkButton>
    </div>
  );
};

export default InfoView;
